import React, { useEffect, useState } from 'react'
import { Button, Divider, Header, Text } from '@wework/dieter-ui'
import { Dropdown, Loader } from 'semantic-ui-react'
import { withFloorMap, withManager } from '@wework/react-floormap'
import _ from 'lodash'
import withFeatures from '../../hoc/withFeatures'
import compose from '../../utils/compose'
import Row from '../Common/Row'
import { withSnackbar } from '../../hoc/SnackBarProvider'
import { useSidebar } from '../../hoc/withSidebar'
import withEventEmitter from '../../hoc/withEventEmitter'
import CloseIcon from '../../assets/images/CloseIcon.svg'
import IMTheme from '../../style/IMTheme'
import { DotMenu } from '../Icons'

function BuildingInfoProducts({ floorMap, manager, snackBars }) {
  const [selectedProductId, setSelectedProductId] = useState<string>()
  const { openSideBar, closeSideBar } = useSidebar()
  const [data, setData] = useState<any>([])
  const { currentBuilding, currentFloor } = floorMap
  const floorName = _.get(currentFloor, 'name')
  const [loading, setLoading] = useState(false)
  const handleClickOnButton = (id: string) => setSelectedProductId(id)
  const renderMenu = (id: string) => {
    return (
      <Dropdown
        icon={
          <div style={{ paddingLeft: '120px' }}>
            <div
              style={{
                width: 16,
                height: 16,
                margin: 0,
                cursor: 'pointer',
                transform: 'rotate(90deg)',
              }}
              onClick={() => handleClickOnButton(id)}
            >
              <DotMenu color="#000000" />
            </div>
          </div>
        }
        floating
        className="icon"
      >
        <Dropdown.Menu>
          <Dropdown.Item onClick={() => openSideBar('Linkeage')}>
            Link
          </Dropdown.Item>
          <Dropdown.Item>Manage</Dropdown.Item>
          <Dropdown.Item>Archive</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    )
  }
  useEffect(() => {
    setLoading(true)
    const fetchUnlinkedProducts = async () => {
      try {
        const client = manager.getClient()
        const response = await client.get(`/floors/${currentFloor?.uuid}`, {
          'extra_fields[floor]': 'inventory_unlinked',
        })
        const { data, meta } = response
        if (!meta.success) {
          throw new Error(meta.message)
        }
        setLoading(false)
        setData(data.attributes.inventory_unlinked)
      } catch (error) {
        setLoading(false)
        snackBars.addAlert({
          text: `There was a problem getting info, ${error}`,
          variant: 'error',
        })
      }
    }
    fetchUnlinkedProducts()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [manager])
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Row>
          <Header as="h3" style={{ margin: 0 }}>
            Not linked
          </Header>
          <Button
            basic
            onClick={() => closeSideBar()}
            icon={
              <div style={{ width: 18, height: 18 }}>
                <CloseIcon />
              </div>
            }
            style={{
              margin: 0,
            }}
          />
        </Row>
        <Text style={{ marginTop: 28 }} size="huge">
          {floorName}
        </Text>
        <Divider light style={{ margin: '24px 0px 0px 0px' }} />
        {loading ? (
          <div
            style={{
              height: 150,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Loader active style={{ position: 'fixed' }} size="small" />
            <span style={{ marginTop: 12 }}>Loading...</span>
          </div>
        ) : (
          <>
            {data.map(({ uuid, name, type }) => (
              <Row key={uuid} justify="space-between">
                <div>
                  <Text
                    style={{
                      marginTop: IMTheme.spacing[5],
                      fontSize: IMTheme.fontSizes[3],
                    }}
                  >
                    {name}
                  </Text>
                  <Text
                    style={{
                      fontSize: IMTheme.fontSizes[1],
                      color: IMTheme.colors.darkGray,
                    }}
                  >
                    {type}
                  </Text>
                </div>
                {renderMenu(uuid)}
              </Row>
            ))}
          </>
        )}
      </div>
    </>
  )
}

export default compose(
  withFloorMap(),
  withFeatures(),
  withEventEmitter(),
  withManager()
)(withSnackbar(BuildingInfoProducts))
